// extracted by mini-css-extract-plugin
module.exports = {"accordionContent":"AuditorAccordions_accordionContent__2mIwh","divider":"AuditorAccordions_divider__2aGRZ"};